import { useQuery } from '@tanstack/react-query';
import { useMemo, useState } from 'react';
import { HttpLCSLHPTI } from '../api/httpLCSLSHPTI';
import { OperacionLCSLHPTITablaValorHistoricoGrupo } from '../types/dto';
import { OperacionLCSLHPTITablaValorHistoricoFields } from '../types/fields';
import { pivotLCSLHPTIData } from './useLCSLHPTITablaValor';

export const useLCSLHPTITablaValorHistorico = (idOperacion: number | undefined | null) => {
  const [versionIndex, setVersionIndex] = useState<number>(0);

  const {
    data: versiones = [],
    isLoading,
    isError,
    error,
    refetch
  } = useQuery<OperacionLCSLHPTITablaValorHistoricoGrupo[], Error>({
    queryKey: ['LCSLHPTI-tabla-valor-historico', idOperacion],
    queryFn: () => HttpLCSLHPTI.getTablaValoresHistorico(idOperacion!),
    enabled: !!idOperacion
  });

  const versionActual = versiones[versionIndex];

  const pivotData = useMemo(() => {
    if (!versionActual) return { groupedHeaders: [], rows: [] };

    const celdasPlanas = versionActual[OperacionLCSLHPTITablaValorHistoricoFields.Celdas] || [];

    return pivotLCSLHPTIData(celdasPlanas);
  }, [versionActual]);

  return {
    versiones,
    versionActual,
    versionIndex,
    setVersionIndex,

    groupedHeaders: pivotData.groupedHeaders,
    rows: pivotData.rows,

    isLoading,
    isError,
    error,
    refetch
  };
};